import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from 'pac-api';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { empty } from '../helpers';
import { LoginModel } from '../model/login.model';
import { WizardStep } from '../wizard-step';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';
import { WizardService } from '../wizard/wizard.service';
import { AddressService } from './../address/address.service';
import { AppComponent } from './../app.component';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit, WizardStep {

  static readonly Name = 'LoginComponent';
  readonly Name = 'LoginComponent';

  private _isSaving: boolean;

  login: LoginModel;
  form: UntypedFormGroup;

  public get isSaving(): boolean {
    return this._isSaving;
  }

  public set isSaving(value: boolean) {
    this._isSaving = value;
    this.app.wait(value);
  }

  get Email(): AbstractControl {
    return this.form.get('Email');
  }

  get Pass(): AbstractControl {
    return this.form.get('Pass');
  }

  @ViewChild('email', { read: ElementRef }) email: ElementRef;
  @ViewChild('pass', { read: ElementRef }) pass: ElementRef;

  public EmailHasError: Observable<boolean>;
  public PassHasError: Observable<boolean>;

  constructor(
    private loginService: LoginService,
    private wizard: WizardService,
    private navigation: WizardNavigationService,
    private address: AddressService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private app: AppComponent,
    public settings: AppSettings,
  ) {
    this.isSaving = false;
  }

  ngOnInit() {
    this.login = new LoginModel();

    if (this.route.snapshot.paramMap.has('email')) {
      this.login.Email = this.route.snapshot.paramMap.get('email');
    }

    const Email = new UntypedFormControl(this.login.Email, [Validators.required, Validators.email]),
          Pass = new UntypedFormControl(this.login.Pass, [Validators.required]);

    this.form = new UntypedFormGroup({
      Email,
      Pass,
    });

    this.EmailHasError = this.Email.statusChanges.pipe(
      map(status => status === 'INVALID' && (Email.dirty || Email.touched)),
      shareReplay(1),
    );

    this.PassHasError = this.Pass.statusChanges.pipe(
      map(status => status === 'INVALID' && (Pass.dirty || Pass.touched)),
      shareReplay(1),
    );
  }

  ngAfterViewInit() {
    if (this.login.Email) {
      this.pass.nativeElement.focus();
    } else {
      this.email.nativeElement.focus();
    }
  }

  ready(): boolean {
    return true;
  }

  OnSubmit() {
    this.isSaving = true;

    this.login.Email = this.form.value.Email;
    this.login.Pass = this.form.value.Pass;

    this.changeDetector.detectChanges();

    this.loginService.login(this.login).subscribe(result => {
      if (result.status === false) {
        this.form.get('Pass').setErrors({
          error: result.error || [],
          warning: result.warning || []
        });

        this.isSaving = false;
      } else {
        this.wizard.setIndiviudal(result.individual);

        if (!empty(result.individual.cxa_key)) {
          this.wizard.Address = this.address.GetAddress(result.individual.cxa_key);
          this.wizard.Address.subscribe(address => {
            this.wizard.setAddress(address);
          });
        }

        this.navigation.next(this);
      }
    }, result => {
      if ('error' in result) {
        this.form.get('Pass').setErrors({
          error: result.error.error || [],
          warning: result.error.warning || []
        });
      }

      this.isSaving = false;
    });
  }
}
